import { parseDiscussionCardMediaItems, type DiscussionCardMediaItem } from "@/main/react/card/DiscussionCardMedia";
import { buildOrderedImageUrls } from "@/main/react/image/ImageCarouselDisplayer";

function toUniqueKey(item: DiscussionCardMediaItem): string {
    return `${item.kind}|${item.provider ?? ""}|${item.sourceUrl}|${item.previewImageUrl ?? ""}`;
}

function addMediaItem(
    orderedItems: DiscussionCardMediaItem[],
    seenKeys: Set<string>,
    item: DiscussionCardMediaItem | null,
) {
    if (!item) {
        return;
    }

    const uniqueKey = toUniqueKey(item);
    if (seenKeys.has(uniqueKey)) {
        return;
    }

    seenKeys.add(uniqueKey);
    orderedItems.push(item);
}

function toImageItem(url: string): DiscussionCardMediaItem {
    return {
        kind: "image",
        sourceUrl: url,
        previewImageUrl: url,
    };
}

function getSeriesMediaPreviewUrl(item?: DiscussionCardMediaItem | null): string | null {
    if (!item) {
        return null;
    }

    return item.kind === "image"
        ? item.sourceUrl
        : item.previewImageUrl ?? null;
}

export function buildSeriesCardMediaItems(input: {
    thumbnailUrl?: unknown;
    imageUrls?: unknown;
    cardMediaItems?: unknown;
}): DiscussionCardMediaItem[] {
    const orderedItems: DiscussionCardMediaItem[] = [];
    const seenKeys = new Set<string>();

    const explicitThumbnail = buildOrderedImageUrls({
        thumbnailUrl: input.thumbnailUrl,
        imageUrls: [],
    })[0];

    if (explicitThumbnail) {
        addMediaItem(orderedItems, seenKeys, toImageItem(explicitThumbnail));
    }

    parseDiscussionCardMediaItems(input.cardMediaItems).forEach((item) => {
        addMediaItem(orderedItems, seenKeys, item);
    });

    if (orderedItems.length > 0) {
        return orderedItems;
    }

    buildOrderedImageUrls({
        thumbnailUrl: input.thumbnailUrl,
        imageUrls: input.imageUrls,
    }).forEach((url) => {
        addMediaItem(orderedItems, seenKeys, toImageItem(url));
    });

    return orderedItems;
}

export function getSeriesDisplayThumbnailUrl(input: {
    thumbnailUrl?: unknown;
    imageUrls?: unknown;
    cardMediaItems?: unknown;
}): string | undefined {
    return getSeriesMediaPreviewUrl(buildSeriesCardMediaItems(input)[0]) ?? undefined;
}
